import React, { useEffect, useState } from 'react';
import HeaderFFF from '../../../components/HeaderFFF'
import Header from '../../../components/Header'
import Footer from "../../../components/Footer";
import { Link } from 'react-router-dom';
import '../../../styles/injury.css'

export default function FatalAccident() {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1000);
    
        useEffect(() => {
            const handleResize = () => {
                setIsMobile(window.innerWidth <= 991);
            };
    
            window.addEventListener('resize', handleResize);
            return () => window.removeEventListener('resize', handleResize);
        }, []);
    
        return(
            <>
            {isMobile ? <Header /> : <HeaderFFF />}
        <div id="injury">
            <div id="fields-header-container">
                <svg xmlns="http://www.w3.org/2000/svg" width="102" height="2" viewBox="0 0 102 2" fill="none">
                    <path d="M101 1H1" stroke="#BF9874" stroke-width="2" stroke-linecap="round"/>
                </svg>
                <h2>Fatal Accident Compensation Claims</h2>
                <svg xmlns="http://www.w3.org/2000/svg" width="102" height="2" viewBox="0 0 102 2" fill="none">
                    <path d="M101 1H1" stroke="#BF9874" stroke-width="2" stroke-linecap="round"/>
                </svg>
            </div>
            <div className="pi-go-back">
                        <Link to="/fields-of-expertise/personal-injury">Take me back</Link>
                </div>
            <div className="pi-text">
                <p>Anyone who has unexpectedly lost a loved one in a fatal accident can rest assured that the fatal
accident lawyers at CLV will be there to assist them with filing <b>fatal accident compensation
claims</b>. We will ensure that families of the deceased fully understand their rights and their
options in this devastating situation. Our mission is to make obtaining fatal injury compensation
as seamless as possible. Enduring a fatal accident is emotionally trying and we put forth our
absolute best efforts to help our clients receive the fatal accident and injury compensation they
deserve. Our fatal accident lawyers will work tirelessly to complete our clients’ fatal accident
claims efficiently so they have one less technicality to worry about.<br/><br/>
<span className="pi-sub-section">Common Types of Fatal Accident Cases We Handle</span><br/><br/>
<b>Fatal Car Accidents</b><br/><br/>
Negligent driving is an inexcusable offense and our devoted fatal car accident lawyers will fight
on behalf of the bereaved to ensure the liable culprits face justice.<br/><br/>

<b>Fatal Truck Accidents</b><br/><br/>
If a loved one loses their life as a consequence of a fatigued and overworked truck driver,
contact our fatal truck accident lawyers immediately.<br/><br/>
<b>Fatal Motorcycle Accidents</b><br/><br/>
Motorcyclists lose their lives too frequently in freak accidents caused by other people’s reckless
and inattentive driving. Our fatal motorcycle accident lawyers are always prepared to protect the
rights of their families.<br/><br/>
<b>Workplace Fatal Accidents</b><br/><br/>
Workplace fatal accidents can include falling from great heights, being struck by a moving
transport vehicle, and being struck by machinery in motion.<br/><br/>
<b>Maritime Fatal Accidents</b><br/><br/>
Many people do not realize how dangerous working on a boat or ship is, but Maritime fatal
accidents happen regularly. Companies are responsible for implementing proper protocols to
protect their employees.<br/><br/>
<b>Helicopter Fatal Accidents</b><br/><br/>
Helicopters are very complex pieces of machinery, and fatal accidents can occur very easily if
they are not properly and regularly maintained. That is why it is important to have a lawyer who
comprehends aviation mechanics and laws be fighting on your behalf.<br/><br/>
<b>Organized Events and Trips Fatal Accidents</b><br/><br/>
If a poorly planned and prepared outing causes a fatal accident, then our fatal accident
lawyers are ready to take legal action for you.<br/><br/>

<b>Public Transport Fatal Accidents</b><br/><br/>
Public transport drivers are responsible for ensuring their vehicles are clean, safe, and well-
maintained. However, accidents do happen, and our fatal accident lawyers are here to help
those who have lost loved ones in a fatal public transport accident.<br/><br/>
<b>Pedestrian Fatal Accidents</b><br/><br/>
Fatal pedestrian accidents entail a pedestrian being struck and killed by a vehicle. Let our highly
qualified fatal accident lawyers handle this for you.<br/><br/>
<b>CLV</b> handles personal injury claims ranging from car and road accidents, slips and falls, and
catastrophic claims. We are equipped to handle the most complex legal and insurance issues
arising from your accident.</p>
            </div>
            <div className="pi-go-back">
                        <Link to="/fields-of-expertise/personal-injury">Take me back</Link>
                </div>
        </div>
            <Footer />
        </>
        );
}